import * as DialogPrimitive from '@radix-ui/react-dialog'
import { useSearchParams } from 'react-router'
import { siteContent } from '#app/utils/site/content'
import { APPLY_LINK_NEEDED_PARAM } from '#app/utils/site/site-links'
import { ArrowIcon, BigHeading } from './primitives'

const copy = siteContent.getStarted

/**
 * "Application link needed". The screening page sends a signed-in tenant
 * with no application to `/?apply-link-needed=1`; this opens on that
 * parameter and drops it when closed. Applications only start from the link
 * a landlord shares. Rendered once by the root, in the website's own look.
 */
export function GetStartedDialog() {
	const [searchParams, setSearchParams] = useSearchParams()
	return (
		<DialogPrimitive.Root
			open={searchParams.has(APPLY_LINK_NEEDED_PARAM)}
			onOpenChange={(next) => {
				if (next) return
				const params = new URLSearchParams(searchParams)
				params.delete(APPLY_LINK_NEEDED_PARAM)
				setSearchParams(params, { replace: true })
			}}
		>
			<DialogPrimitive.Portal>
				<DialogPrimitive.Overlay className="fixed inset-0 z-[70] flex items-center justify-center bg-tt-ink/40 p-4 backdrop-blur-sm">
					<DialogPrimitive.Content className="tt-site relative w-full max-w-[720px] rounded-[28px] !bg-white px-7 pb-7 pt-8 text-tt-ink shadow-tt-card focus-visible:outline-none min-[601px]:px-10 min-[601px]:pb-9 min-[601px]:pt-11">
						<DialogPrimitive.Close
							aria-label={copy.close}
							className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-tt-line bg-white text-tt-ink transition-colors duration-200 hover:border-tt-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tt-ink focus-visible:ring-offset-2 min-[601px]:right-6 min-[601px]:top-6"
						>
							<svg
								viewBox="0 0 24 24"
								className="h-[18px] w-[18px]"
								fill="none"
								stroke="currentColor"
								strokeWidth={2}
								strokeLinecap="round"
								aria-hidden="true"
							>
								<path d="M6 6l12 12M18 6L6 18" />
							</svg>
						</DialogPrimitive.Close>
						<DialogPrimitive.Title asChild>
							<BigHeading as="h2" className="pr-12 text-[clamp(40px,7vw,64px)]">
								{copy.dialogTitle}
							</BigHeading>
						</DialogPrimitive.Title>
						<DialogPrimitive.Description className="mt-5 text-[17px] leading-[1.5] text-tt-body min-[601px]:text-[18px]">
							{copy.dialogIntro}
						</DialogPrimitive.Description>
						<div className="mt-8 flex flex-wrap items-center justify-end gap-4">
							<DialogPrimitive.Close className="inline-flex items-center gap-2 rounded-full bg-tt-ink px-8 py-[17px] text-[17px] font-semibold leading-tight text-white transition-[transform,opacity] duration-200 ease-tt hover:-translate-y-px focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-tt-ink focus-visible:ring-offset-2">
								{copy.ok}
								<ArrowIcon />
							</DialogPrimitive.Close>
						</div>
					</DialogPrimitive.Content>
				</DialogPrimitive.Overlay>
			</DialogPrimitive.Portal>
		</DialogPrimitive.Root>
	)
}
